var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPersonalLeave = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2598_44430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 13.3333H9.5C9.04167 13.3333 8.66667 12.9583 8.66667 12.5H2.84167V15.8333C2.84167 16.75 3.59167 17.5 4.50833 17.5H16.1667C17.0833 17.5 17.8333 16.75 17.8333 15.8333V12.5H12C12 12.9583 11.625 13.3333 11.1667 13.3333ZM17 5.83333H13.6667C13.6667 3.99167 12.175 2.5 10.3333 2.5C8.49167 2.5 7 3.99167 7 5.83333H3.66667C2.75 5.83333 2 6.58333 2 7.5V10C2 10.925 2.74167 11.6667 3.66667 11.6667H8.66667V10.8333C8.66667 10.375 9.04167 10 9.5 10H11.1667C11.625 10 12 10.375 12 10.8333V11.6667H17C17.9167 11.6667 18.6667 10.9167 18.6667 10V7.5C18.6667 6.58333 17.9167 5.83333 17 5.83333ZM8.66667 5.83333C8.66667 4.91667 9.41667 4.16667 10.3333 4.16667C11.25 4.16667 12 4.91667 12 5.83333H8.65833H8.66667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2598_44430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.335938)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPersonalLeave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/personalLeave.0dda5b88.svg";
export { ForwardRef as ReactComponent };